module.exports = __webpack_public_path__ + "img/icon-06.b64915f1.svg";